import { API_URL } from 'config';
import { useNotificationStore } from 'stores/notifications';
import storage from 'utils/storage';
import Axios from 'axios';
import PropTypes from 'prop-types';

// -----------------------------------------------------------------------------
// DEVICE FINGERPRINT
// -----------------------------------------------------------------------------
function getDeviceFingerprint() {
  let fingerprint = storage.getDeviceFingerprint();

  if (!fingerprint) {
    const raw = [
      navigator.userAgent,
      navigator.language,
      screen.width,
      screen.height,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
    ].join('|');

    fingerprint = btoa(raw);
    storage.setDeviceFingerprint(fingerprint);
  }

  return fingerprint;
}

// -----------------------------------------------------------------------------
// REQUEST INTERCEPTOR
// -----------------------------------------------------------------------------
function authRequestInterceptor(config) {
  const token = storage.getToken();
  const fingerprint = getDeviceFingerprint();

  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }

  // REQUIRED for new login system
  config.headers['x-device-fingerprint'] = fingerprint;

  config.headers.Accept = 'application/json';
  return config;
}

authRequestInterceptor.propTypes = {
  config: PropTypes.any,
};

// -----------------------------------------------------------------------------
// AXIOS INSTANCE
// -----------------------------------------------------------------------------
export const axios = Axios.create({
  baseURL: API_URL,
});

axios.defaults.timeout = 50000;
axios.defaults.timeoutErrorMessage = '😟 Server is taking longer than usual to respond.';

// NOTE: Keep this if you truly need multipart globally
axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

axios.interceptors.request.use(authRequestInterceptor);

axios.interceptors.response.use(
  (response) => response.data,
  (error) => {
    useNotificationStore.getState().addNotification({
      type: 'error',
      title: 'Error',
      message: error.response?.data?.message || 'An error occurred. Please try again.',
    });

    return Promise.reject(error);
  }
);
